export default __webpack_public_path__ + "25ca549f0de07502e3d18324634ae56c.svg";